import { apiSlice } from "./apiSlice";

const apiSliceWithTags = apiSlice.enhanceEndpoints({
  addTagTypes: ["Duels"],
});

const duelApiSlice = apiSliceWithTags.injectEndpoints({
  endpoints: (builder) => ({
    getDuel: builder.query({
      query: (id) => `/duel/${id}`,
      providesTags: ["Duels"],
    }),
    getDuelHistory: builder.query({
      query: ({ page = 1, per_page = 10 } = {}) =>
        `/duel/history?page=${page}&per_page=${per_page}`,
      providesTags: ["Duels"],
    }),
    joinDuelQueue: builder.mutation({
      query: () => ({
        url: "/duel/queue/join",
        method: "POST",
      }),
    }),
    leaveDuelQueue: builder.mutation({
      query: () => ({
        url: "/duel/queue/leave",
        method: "POST",
      }),
    }),
    proposeDuelSettings: builder.mutation({
      query: ({ id, ...body }) => ({
        url: `/duel/${id}/propose`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["Duels"],
    }),
    acceptDuel: builder.mutation({
      query: (id) => ({
        url: `/duel/${id}/accept`,
        method: "POST",
      }),
      invalidatesTags: ["Duels"],
    }),
    rejectDuel: builder.mutation({
      query: (id) => ({
        url: `/duel/${id}/reject`,
        method: "POST",
      }),
      invalidatesTags: ["Duels"],
    }),
    getDuelByQuizId: builder.query({
      query: (quiz_id) => `/duel/by-quiz/${quiz_id}`,
      providesTags: ["Duels"],
    }),
  }),
});

export const {
  useGetDuelQuery,
  useGetDuelHistoryQuery,
  useJoinDuelQueueMutation,
  useLeaveDuelQueueMutation,
  useProposeDuelSettingsMutation,
  useAcceptDuelMutation,
  useRejectDuelMutation,
  useGetDuelByQuizIdQuery,
} = duelApiSlice;
